import { render, staticRenderFns } from "./NavBarComponent.vue?vue&type=template&id=4b484872&scoped=true&"
import script from "./NavBarComponent.vue?vue&type=script&lang=js&"
export * from "./NavBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavBarComponent.vue?vue&type=style&index=0&id=4b484872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b484872",
  null
  
)

export default component.exports